import {useEffect, useState} from 'react'

export const PhysicalSiteContacts = props => {
  const {siteContacts, onChange} = props

  const [sites, setSites] = useState(siteContacts ? siteContacts : [])

  const onInputChange = (e, index, property) => {
    const _sites = [...sites]
    _sites[index][property] = e.target.value
    setSites(_sites)
  }

  const add = () => {
    const _sites = [...sites]
    _sites.push({
      name: '',
      email: ''
    })
    setSites(_sites)
  }

  const remove = index => {
    const _sites = [...sites]
    _sites.splice(index, 1)
    setSites(_sites)
  }

  useEffect(() => {
    onChange(sites)
  }, [sites])

  return (
    <>
      <h4>Physical site contacts (optional)</h4>
      <table className="vw-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>&nbsp; </th>
          </tr>
        </thead>
        <tbody>
          {sites.map((site, index) => (
            <tr key={`physical-site-${index}`}>
              <td>
                <div className="vw-table__name">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    value={site.name}
                    onChange={e => onInputChange(e, index, 'name')}
                  />
                </div>
              </td>
              <td>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={site.email}
                  onChange={e => onInputChange(e, index, 'email')}
                />
              </td>
              <td>
                <button
                  type="button"
                  className="btn btn-link text-decoration-none"
                  onClick={() => remove(index)}
                >
                  <i className="fal fa-minus"></i>
                  <span className="ml-1">Remove</span>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="vw-group-button">
        <button className="btn btn-add btn-add--lg vw-tab-group-button" onClick={add}>
          <i className="fal fa-plus"></i>
        </button>
      </div>
    </>
  )
}
